import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Swal from 'sweetalert2';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import InputGroup from 'react-bootstrap/InputGroup';
import {useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FixedButton from '../FixedButton';
import { quotationAPI } from '../../redux/actionCreation';
import MobileNavigation from '../MobileNavigation';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Loader from '../Loader';
import Select from "react-select";
import { Country, State, City } from "country-state-city";

function CretaeQuotation() {
    useEffect(()=>{
        if(!localStorage.getItem('tokan')){
            navigate('/login');
        }
    }, []);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const [loading, setLoading] = useState(false);
    const sidebarState = useSelector(state => state.sidebarReducres);
    const error = useSelector(state => state.quotationReducers.error && state.quotationReducers.error.create_quotation_errors);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({  
            quotation_date: today,
            name: '',
            phone_number: '',
            service_name: '',
            c_gst:'',
            shift_start_date: '',
            shift_end_date: '',   
            customer_address: '',
            from_state: '',      // Added missing 'from_state'
            from_city: '',
            select_floor: '',    // Added missing 'select_floor'
            select_lift: '',     // Added missing 'select_lift'
            from_address: '',    // Added missing 'from_address'
            to_state: '',        // Added missing 'to_state'
            to_city: '',  // Added missing 'to_address'
            select_to_floor: '',    // Added missing 'select_floor'
            select_to_lift: '',     // Added missing 'select_lift'
            to_address: '', 
            shift_items: '', 
            enter_total_amt:'',
            transportation_charge: '',
            packing_charge: '',
            unpacking_charge: '',
            loading_charge: '',
            unloading_charge: '',
            insurance_charge: '',
            storage_charge: '',
            other_charge: '',
            total_charge: '',
            gst_hide_show:'Without GST Quotation',
            gst_type:'IGST',
            gst_per:'5',
            total_gst_charge:'',
            service_charge: '',
            Notes:'',
  });

  const resetForm = async () => {
    const confirmation = await Swal.fire({
        icon: 'question',
        title: 'Are you sure?',
        text: 'This will reset the form. Are you sure you want to proceed? - यह फ़ॉर्म रीसेट हो जाएगा। क्या आप वाकई आगे बढ़ना चाहते हैं?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
    });
    if (confirmation.isConfirmed) {
        setFormData({
            quotation_date: '',
            name: '',
            phone_number: '',
            service_name: '',
            c_gst:'',
            shift_start_date: '',
            shift_end_date: '',   
            customer_address: '',
            from_state: '',      // Added missing 'from_state'
            from_city: '',
            select_floor: '',    // Added missing 'select_floor'
            select_lift: '',     // Added missing 'select_lift'
            from_address: '',    // Added missing 'from_address'
            to_state: '',        // Added missing 'to_state'
            to_city: '',  // Added missing 'to_address'
            select_to_floor: '',    // Added missing 'select_floor'
            select_to_lift: '',     // Added missing 'select_lift'
            to_address: '', 
            shift_items: '',
            enter_total_amt:'',
            transportation_charge: '',
            packing_charge: '',
            unpacking_charge: '',
            loading_charge: '',
            unloading_charge: '',
            insurance_charge: '',
            storage_charge: '',
            other_charge: '',
            total_charge: '',
            gst_hide_show:'Without GST Quotation',
            gst_type:'IGST',
            gst_per:'5',
            total_gst_charge:'',
            service_charge: '',
            Notes:'',
        });
    }
    
  };

    // <strong className="text-primary">Include in Total</strong> functions
        const chargesConfig = [
        { key: 'transportation', label: 'Transportation Charge' },
        { key: 'packing', label: 'Packing Charge' },
        { key: 'unpacking', label: 'Unpacking Charge' },
        { key: 'loading', label: 'Loading Charge' },
        { key: 'unloading', label: 'Unloading Charge' },
        { key: 'insurance', label: 'Insurance Charge' },
        { key: 'storage', label: 'Storage Charge' },
        { key: 'service', label: 'Service Charge' },
        { key: 'other', label: 'Other Charge' },
        ];

        const initialIncludeState = {};
        const initialFormData = {};

        chargesConfig.forEach(item => {
        initialIncludeState[item.key] = true;
        initialFormData[`${item.key}_charge`] = '0'; // default Include
        });

        const [includeCharge, setIncludeCharge] = useState(initialIncludeState);
        const [formDatainclude, setFormDatainclude] = useState(initialFormData);

        // Checkbox toggle
        const handleIncludeToggle = (key) => (e) => {
        const checked = e.target.checked;

        setIncludeCharge(prev => ({
            ...prev,
            [key]: checked,
        }));

        setFormDatainclude(prev => ({
            ...prev,
            [`${key}_charge`]: checked ? '0' : '', // unchecked -> blank
        }));
        };

        // Traportation etc charge input on change
        const handleChangeCharge = (e) => {
        const { name, value } = e.target;

        // Allow only digits (0–9)
        if (!/^\d*$/.test(value)) {
            return;
        }

        const key = name.replace('_charge', '');
        if (!includeCharge[key]) {
            setFormDatainclude(prev => ({
            ...prev,
            [name]: value,
            }));
        }
        };

        const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
        };

   // Function to calculate total of specified fields
//    const calculateTotal = () => {
//     const {
//       enter_total_amt,
//       transportation_charge,
//       packing_charge,
//       unpacking_charge,
//       loading_charge,
//       unloading_charge,
//       insurance_charge,
//       storage_charge,
//       other_charge,
//     } = formData;

//     const total =
//       parseFloat(enter_total_amt) +
//       parseFloat(transportation_charge) +
//       parseFloat(packing_charge) +
//       parseFloat(unpacking_charge) +
//       parseFloat(loading_charge) +
//       parseFloat(unloading_charge) +
//       parseFloat(insurance_charge) +
//       parseFloat(storage_charge) +
//       parseFloat(other_charge);
//     return total;
//   };


// Calculation Function
const calculateTotal = () => {
    // Base amount jo 'formData' mein hai
    let total = parseFloat(formData.enter_total_amt) || 0;
    console.log("enter am",total);
    // Baaki charges jo dynamic hain 'formDatainclude' se loop karke add honge
    chargesConfig.forEach(({ key }) => {
        const fieldName = `${key}_charge`;
        const val = parseFloat(formDatainclude[fieldName]) || 0;
        total += val;
    });

    return total;
};

// 2. useEffect: Jaise hi koi bhi input change ho, total apne aap update ho jaye
useEffect(() => {
    const finalTotal = calculateTotal();
    
    // Agar aap total ko formData state mein save karna chahte hain:
    setFormData(prev => ({
        ...prev,
        total: finalTotal
    }));
}, [formData.enter_total_amt, formDatainclude]); // In dono states ke badalne par chalega
  
// // Function to calculate SGST charge based on total and cgst_per
// const calculateSGSTCharge = (total, gst_per) => {
//     return (total * parseFloat(gst_per)) / 100;
//   };

//   // Function to calculate CGST charge based on total and cgst_per
//   const calculateCGSTCharge = (total, gst_per) => {
//     return (total * parseFloat(gst_per)) / 100;
//   };
  
  // Function to calculate IGST charge based on total and gst_per
// 1. GST Calculation Helper

// Variable bana lete hain taaki code saaf dikhe
const isGstEnabled = formData.gst_hide_show === "GST Charge Show" || formData.gst_hide_show === "GST Included in Freight Charge";

useEffect(() => {
  const total = calculateTotal(); 
  
  let gstCharge = 0;
  let cgstCharge = 0;
  let sgstCharge = 0;
  let igstCharge = 0;

  // Condition 1: Agar "GST Charge Show" hai toh calculate karo
  if (formData.gst_hide_show === "GST Charge Show") {
    const gstPer = parseFloat(formData.gst_per) || 0;
    gstCharge = (total * gstPer) / 100;

    if (formData.gst_type === "CGST/SGST") {
      cgstCharge = gstCharge / 2;
      sgstCharge = gstCharge / 2;
    } else {
      igstCharge = gstCharge;
    }
  } 
  // Condition 2: Agar "Included" hai, toh Type/Percent state mein rahega par Charge 0 rahega
  else if (formData.gst_hide_show === "GST Included in Freight Charge") {
    gstCharge = 0;
    cgstCharge = 0;
    sgstCharge = 0;
    igstCharge = 0;
    // Note: Yahan hum calculate nahi kar rahe kyunki wo price mein already include hai
  }
  // Condition 3: Without GST
  else {
    gstCharge = 0;
    cgstCharge = 0;
    sgstCharge = 0;
    igstCharge = 0;
  }

  const finalAmount = total + gstCharge;

  setFormData((prevData) => ({
    ...prevData,
    total_charge: total.toFixed(2),
    total_gst_charge: gstCharge.toFixed(2),
    cgst_charge: cgstCharge.toFixed(2),
    sgst_charge: sgstCharge.toFixed(2),
    igst_charge: igstCharge.toFixed(2),
    total_amount: finalAmount.toFixed(2),
  }));

}, [
  formData.enter_total_amt,
  formDatainclude,
  formData.gst_hide_show,
  formData.gst_type,
  formData.gst_per,
]);
  
  const handleQuoteDateChange = (date) => {
    const modifiedDate = new Date(date);
    modifiedDate.setHours(0, 0, 0, 0);
    // Format the date to "dd-mm-yyyy"
    const day = String(modifiedDate.getDate()).padStart(2, '0');
    const month = String(modifiedDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = String(modifiedDate.getFullYear());

    const formattedDate = `${day}-${month}-${year}`;
    console.log("date", formattedDate);
    // Update the recipts_date field in formData when the DatePicker changes
    setFormData((prevState) => ({
        ...prevState,
        quotation_date: modifiedDate,
    }));
};

//   const handleStartDateChange = (date) => {
//     const modifiedDate = new Date(date);
//     modifiedDate.setHours(0, 0, 0, 0);
//     // Format the date to "dd-mm-yyyy"
//     const day = String(modifiedDate.getDate()).padStart(2, '0');
//     const month = String(modifiedDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
//     const year = String(modifiedDate.getFullYear());

//     const formattedDate = `${day}-${month}-${year}`;
//     console.log("date", formattedDate);
//     // Update the recipts_date field in formData when the DatePicker changes
//     setFormData((prevState) => ({
//         ...prevState,
//         shift_start_date: modifiedDate,
//     }));
//   };

//   const handleEndDateChange = (date) => {
//     const modifiedDate = new Date(date);
//     modifiedDate.setHours(0, 0, 0, 0);
//     // Format the date to "dd-mm-yyyy"
//     const day = String(modifiedDate.getDate()).padStart(2, '0');
//     const month = String(modifiedDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
//     const year = String(modifiedDate.getFullYear());

//     const formattedDate = `${day}-${month}-${year}`;
//     console.log("date", formattedDate);
//     // Update the recipts_date field in formData when the DatePicker changes
//     setFormData((prevState) => ({
//         ...prevState,
//         shift_end_date: modifiedDate,
//     }));
//   };

const handleStartDateChange = (date) => {
    const modifiedDate = new Date(date);
    modifiedDate.setHours(0, 0, 0, 0);
    // Format the date to "dd-mm-yyyy"
    const day = String(modifiedDate.getDate()).padStart(2, '0');
    const month = String(modifiedDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = String(modifiedDate.getFullYear());

    const formattedDate = `${day}-${month}-${year}`;
    console.log("date", formattedDate);

    // Update shift_start_date and update shift_end_date only if it hasn't been manually changed
    setFormData((prevState) => ({
        ...prevState,
        shift_start_date: modifiedDate,
        shift_end_date: (!prevState.shift_end_date || prevState.shift_end_date === prevState.shift_start_date) 
            ? modifiedDate 
            : prevState.shift_end_date
    }));
};

const handleEndDateChange = (date) => {
    const modifiedDate = new Date(date);
    modifiedDate.setHours(0, 0, 0, 0);
    // Format the date to "dd-mm-yyyy"
    const day = String(modifiedDate.getDate()).padStart(2, '0');
    const month = String(modifiedDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = String(modifiedDate.getFullYear());

    const formattedDate = `${day}-${month}-${year}`;
    console.log("date", formattedDate);
    
    // Update shift_end_date when user manually changes it
    setFormData((prevState) => ({
        ...prevState,
        shift_end_date: modifiedDate,
    }));
};


const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    // Dono states ko yahan merge karein
    const finalData = {
        ...formData,          // Basic details (name, phone, etc.)
        ...formDatainclude,   // Saare charges (transportation, packing, etc.)
        total_charge: calculateTotal(), // Final confirm total bhi bhej dein
    };

    try {
        // Ab formData ki jagah finalData bhejein
        const res = await dispatch(quotationAPI(finalData)); 
        
        setLoading(false);
        if(res?.type == "ADD_DATA_SUCCESS"){
            navigate("/quoteone");
        }
        else {
            await Swal.fire({
                icon: 'error',
                title: 'Some Error',
                text: 'Please check your form. Some fields are not filled in properly.',
            });
        }
    } catch (error) {
        setLoading(false);
        console.error('Error:', error);
    }
};


  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

const [selectedToState, setSelectedToState] = useState(null);
const [selectedToCity, setSelectedToCity] = useState(null);


  // Get Indian states
// Get Indian states
const states = State.getStatesOfCountry("IN").map((state) => ({
    value: state.name,     // Database mein "Gujarat" jayega
    label: state.name,     // Dropdown mein "Gujarat" dikhega
    isoCode: state.isoCode // City load karne ke liye internal use (GJ)
}));

// "From" cities filter logic
const cities = selectedState 
    ? City.getCitiesOfState("IN", selectedState.isoCode).map((city) => ({
        value: city.name,
        label: city.name,
    }))
    : [];

// "To" cities filter logic
const toCities = selectedToState 
    ? City.getCitiesOfState("IN", selectedToState.isoCode).map((city) => ({
        value: city.name,
        label: city.name,
    }))
    : [];

// Handle "From" State Change
const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption); // Pura object store hoga (with isoCode)
    setSelectedCity(null); 
    setFormData((prevData) => ({
        ...prevData,
        from_state: selectedOption ? selectedOption.value : "", // Full Name
        from_city: '', 
    }));
};

// Handle "From" City Change
const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption);
    setFormData((prevData) => ({
        ...prevData,
        from_city: selectedOption ? selectedOption.value : "",
    }));
};

// Handle "To" State Change
const handleToStateChange = (selectedOption) => {
    setSelectedToState(selectedOption); // Isme ab isoCode mil jayega
    setSelectedToCity(null);
    setFormData((prevData) => ({
        ...prevData,
        to_state: selectedOption ? selectedOption.value : "", // Full Name
        to_city: '',
    }));
};

// Handle "To" City Change
const handleToCityChange = (selectedOption) => {
    setSelectedToCity(selectedOption);
    setFormData((prevData) => ({
        ...prevData,
        to_city: selectedOption ? selectedOption.value : "",
    }));
};

  return (
    <>
        {/* <FixedButton/> */}
        <div className={`main-content ${!sidebarState ? '' : 'navbar-ful'}`}>
            <div className='page-content'>
                <Container fluid>
                    <Row>
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className='mb-2'>
                            <h5>Create Quotation</h5>
                        </Col>
                    </Row>
                        <Card className='quotaion-create'>
                            <Card.Body className='p-3'>
                                <Form onSubmit={handleSubmit}>
                                    <Row className="mb-3">
                                        <h6 className='mb-0 bg-gray p-2'>General Details:</h6>
                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                            <hr className='w-10'/>
                                        </Col>
                                        
                                        <Form.Group as={Col} xs="12" sm="12" md="4" lg="4" xl="4" xxl="4" controlId="formGridPassword" className='mt-3'>
                                        <Form.Label>Quotation Date (कोटेशन की तारीख)</Form.Label>
                                            <div className="date-picker-container">
                                                <i className='calendar-icon fa fa-calendar'></i>
                                                <DatePicker
                                                    selected={formData.quotation_date}
                                                    onChange={handleQuoteDateChange}
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Quotation Date"
                                                    className='form-control'
                                                    required
                                                />
                                            </div>
                                        </Form.Group>
                                        
                                        <Form.Group as={Col} xs="12" sm="12" md="4" lg="4" xl="4" xxl="4" controlId="formGridEmail" className='mt-3'>
                                            <Form.Label>Company / Party Name (नाम - जिसे कोटेशन चाहिए) <span class="text-danger">*</span></Form.Label>
                                            <Form.Control type="text" onChange={handleChange} placeholder="Customer Name.." name="name" value={formData.name} required/>

                                            {error?.cust_name && (
                                            <span className="alert alert-danger d-block mt-1 pt-1 mb-1 pb-1">
                                            {error.cust_name && error.cust_name}
                                            </span>
                                            )}
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" sm="12" md="4" lg="4" xl="4" xxl="4" controlId="formGridPassword" className='mt-3'>
                                            <Form.Label>Phone</Form.Label>
                                            <Form.Control type="number" min={0} placeholder="Customer Phone.." onChange={handleChange} name="phone_number" value={formData.phone_number}/>

                                            {error?.phone_greater && (
                                            <span className="alert alert-danger d-block mt-1 pt-1 mb-1 pb-1">
                                            {error.phone_greater && error.phone_greater}
                                            </span>
                                            )}

                                            {error?.phone_less && (
                                            <span className="alert alert-danger d-block mt-1 pt-1 mb-1 pb-1">
                                            {error.phone_less && error.phone_less}
                                            </span>
                                            )}
                                        </Form.Group>   

                                        <Form.Group as={Col} xs="12" sm="12" md="3" lg="3" xl="3" xxl="3" controlId="formGridEmail" className='mt-3'>
                                            <Form.Label>Moving Type (मुविंग के प्रकार) <span class="text-danger">*</span></Form.Label> 
                                            {/* <Form.Control type="text" placeholder="Service Name.." onChange={handleChange} name="service_name" value={formData.service_name} required/> */}

                                            <select className='form-select' id="" onChange={handleChange} name="service_name" value={formData.service_name} required>
                                                    <option value="" disabled>Select Service</option>
                                                    <option value="House Hold Goods">House Hold Goods</option>
                                                    <option value="Local">Local</option>
                                                    <option value="Domestic">Domestic</option>
                                                    <option value="International">International</option>
                                                    <option value="Office Shifting">Office Shifting</option>
                                                    <option value="Industrial Goods Shifting">Industrial Goods Shifting</option>
                                                    <option value="Car Shifting">Car Shifting</option>
                                                    <option value="House Hold Goods And Car Shifting">House Hold Goods And Car Shifting</option>
                                                    <option value="Bike Shifting">Bike Shifting</option>
                                                    <option value="House Hold Goods And Bike Shifting">House Hold Goods And Bike Shifting</option>
                                                    <option value="Car and Bike Shifting">Car and Bike Shifting</option>
                                                    <option value="House Hold Goods, Bike And Car Shifting">House Hold Goods, Bike And Car Shifting</option>
                                                    <option value="Pet Relocation">Pet Relocation</option>
                                                    <option value="House Hold Goods, Bike And Car Shifting, Pet Relocation">House Hold Goods, Bike And Car Shifting, Pet Relocation</option>
                                            </select>
                                        </Form.Group>

                                        

                                        <Form.Group as={Col} xs="12" sm="12" md="3" lg="3" xl="3" xxl="3" controlId="formGridEmail" className='mt-3'>
                                            <Form.Label>Party GST No.</Form.Label>
                                            <Form.Control type="text" placeholder="Customer GST No..." onChange={handleChange} name="c_gst" value={formData.c_gst}/>
                                        </Form.Group>

                                        
                                         <Form.Group as={Col} xs="12" sm="12" md="3" lg="3" xl="3" xxl="3" controlId="formGridEmail" className='mt-3'>
                                        <Form.Label>Packing Start Date</Form.Label>
                                            <div className="date-picker-container">
                                                <i className='calendar-icon fa fa-calendar'></i>
                                                <DatePicker
                                                    selected={formData.shift_start_date}
                                                    onChange={handleStartDateChange}
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Start Date"
                                                    className='form-control'
                                                />
                                            </div>
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" sm="12" md="3" lg="3" xl="3" xxl="3" controlId="formGridEmail" className='mt-3'>
                                        <Form.Label>Moving End Date</Form.Label>
                                            <div className="date-picker-container">
                                                <i className='calendar-icon fa fa-calendar'></i>
                                                <DatePicker
                                                    selected={formData.shift_end_date}
                                                    onChange={handleEndDateChange}
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="End Date"
                                                    className='form-control'
                                                />
                                            </div>
                                            {error?.shift_end_date && (
                                            <span className="alert alert-danger d-block mb-1 mt-1 pt-1 pb-1">
                                            {error.shift_end_date && error.shift_end_date}
                                            </span>
                                            )}
                                        </Form.Group>


                                        <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" controlId="exampleForm.ControlTextarea1" className='mt-3'>
                                            <Form.Label>Party Address (पता)</Form.Label>
                                            <Form.Control as="textarea" rows={3} placeholder="Customer Address.." onChange={handleChange} name="customer_address" value={formData.customer_address}/>
                                        </Form.Group>

                                        <h6 className='mb-0 mt-3 bg-gray p-2'>Move From (जहां से सामान जाएगा):</h6>
                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                            <hr className='w-10'/>
                                        </Col>

                                        <Form.Group as={Col} xs="12" sm="12" md="3" lg="3" xl="3" className="mt-3">
                                            <Form.Label><b>From</b> State (राज्य)<span class="text-danger">*</span></Form.Label>
                                            <Select
                                                id="stateSelect"
                                                options={states}
                                                name="from_state"
                                                required
                                                value={states.find((state) => state.value === formData.from_state)} // Ensure correct value selection
                                                onChange={handleStateChange}
                                                placeholder="Select State"
                                            />
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" sm="12" md="3" lg="3" xl="3" className="mt-3">
                                            <Form.Label><b>From</b> City (शहर)<span class="text-danger">*</span></Form.Label>
                                            <Select
                                                id="citySelect"
                                                options={cities || []}
                                                name="from_city"
                                                required
                                                value={cities?.find((city) => city.value === formData.from_city)} // Ensure correct city selection
                                                onChange={handleCityChange}
                                                placeholder="Select City"
                                            />
                                        </Form.Group>

                                        <div className='form-group mt-3 col-md-12 col-lg-2 col-sm-12 col-xs-12'>
                                            <Form.Label for="exampleSelect2"><b>From</b> Floor (मंज़िल)<span class="text-danger">*</span></Form.Label>
                                            <select className='form-select' id="exampleSelect2" onChange={handleChange} name="select_floor" value={formData.select_floor} required>
                                                <option value="" disabled>Floor Select </option>
                                                <option value="Ground Floor">Ground Floor</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                                <option value="6">6</option>
                                                <option value="7">7</option>
                                                <option value="8">8</option>
                                                <option value="9">9</option>
                                                <option value="10">10</option>
                                                <option value="11">11</option>
                                                <option value="12">12</option>
                                                <option value="13">13</option>
                                                <option value="14">14</option>
                                                <option value="15">15</option>
                                                <option value="16">16</option>
                                                <option value="17">17</option>
                                                <option value="18">18</option>
                                                <option value="19">19</option>
                                                <option value="20">20</option>
                                                <option value="21">21</option>
                                                <option value="22">22</option>
                                                <option value="23">23</option>
                                                <option value="24">24</option>
                                                <option value="25">25</option>
                                                <option value="26">26</option>
                                                <option value="27">27</option>
                                                <option value="28">28</option>
                                                <option value="29">29</option>
                                                <option value="30">30</option>
                                                <option value="30+">30+</option>
                                            </select>
                                        </div>

                                        <Form.Group as={Col} xs="12" sm="12" md="12" lg="4" xl="4" xxl="4" className="mt-3">
                                            <Form.Label><b>From</b> Is Lift Available(क्या लिफ्ट है?)<span class="text-danger">*</span></Form.Label>
                                            <div>
                                            <Form.Check 
                                                type="radio"
                                                label="Service Lift"
                                                name="select_lift"    // Updated name attribute
                                                value="From Service Lift"
                                                id="service Lift"
                                                onChange={handleChange}
                                                checked={formData.select_lift === "From Service Lift"}
                                                inline
                                                required
                                            />
                                            <Form.Check 
                                                type="radio"
                                                label="Passenger Lift"
                                                name="select_lift"    // Updated name attribute
                                                value="From Passenger Lift"
                                                id="passenger_lift"
                                                onChange={handleChange}
                                                checked={formData.select_lift === "From Passenger Lift"}
                                                inline
                                            />
                                            <Form.Check 
                                                type="radio"
                                                label="Stairs"
                                                name="select_lift"    // Updated name attribute
                                                value="From Stairs"
                                                id="stairs"
                                                onChange={handleChange}
                                                checked={formData.select_lift === "From Stairs"}
                                                inline
                                            />
                                        </div>
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" controlId="exampleForm.ControlTextarea1" className='mt-3'>
                                            <Form.Label><b>From</b> Address (पता)</Form.Label>
                                            <Form.Control as="textarea" rows={3} placeholder="Customer Address.." onChange={handleChange} name="from_address" 
                                            value={formData.from_address}
                                            />
                                        </Form.Group>

                                         <h6 className='mb-0 mt-3 bg-gray p-2'>Move To (जहां सामान जाना है):</h6>
                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                            <hr className='w-10'/>
                                        </Col>

                                      {/* Select To State */}
                                            <Form.Group as={Col} xs="12" sm="12" md="3" lg="3" xl="3" className="mt-3">
                                                <Form.Label>Select <b>To</b> State (राज्य)<span className="text-danger">*</span></Form.Label>
                                                <Select
                                                    options={states}
                                                    required
                                                    value={selectedToState}
                                                    onChange={handleToStateChange}
                                                    placeholder="Select State"
                                                />
                                            </Form.Group>

                                            {/* Select To City */}
                                            <Form.Group as={Col} xs="12" sm="12" md="3" lg="3" xl="3" className="mt-3">
                                                <Form.Label>Select <b>To</b> City (शहर)<span className="text-danger">*</span></Form.Label>
                                                <Select
                                                    // FIX: Yahan direct toCities variable use karein
                                                    options={toCities} 
                                                    value={selectedToCity}
                                                    onChange={handleToCityChange}
                                                    placeholder="Select City"
                                                    required
                                                />
                                            </Form.Group>
                                        

                                    <div className='form-group mt-3 col-md-12 col-lg-2 col-sm-12 col-xs-12'>
                                            <Form.Label for="exampleSelect2"><b>To</b> Select (मंज़िल)<span class="text-danger">*</span></Form.Label>
                                            <select className='form-select' id="exampleSelect2" onChange={handleChange} name="select_to_floor" value={formData.select_to_floor} required>
                                                <option value="" disabled>From Floor (मंज़िल) </option>
                                                <option value="Ground Floor">Ground Floor</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                                <option value="6">6</option>
                                                <option value="7">7</option>
                                                <option value="8">8</option>
                                                <option value="9">9</option>
                                                <option value="10">10</option>
                                                <option value="11">11</option>
                                                <option value="12">12</option>
                                                <option value="13">13</option>
                                                <option value="14">14</option>
                                                <option value="15">15</option>
                                                <option value="16">16</option>
                                                <option value="17">17</option>
                                                <option value="18">18</option>
                                                <option value="19">19</option>
                                                <option value="20">20</option>
                                                <option value="21">21</option>
                                                <option value="22">22</option>
                                                <option value="23">23</option>
                                                <option value="24">24</option>
                                                <option value="25">25</option>
                                                <option value="26">26</option>
                                                <option value="27">27</option>
                                                <option value="28">28</option>
                                                <option value="29">29</option>
                                                <option value="30">30</option>
                                                <option value="30+">30+</option>
                                            </select>
                                        </div>

                                        <Form.Group as={Col} xs="12" sm="12" md="12" lg="4" xl="4" xxl="4" className="mt-3">
                                            <Form.Label><b>To</b> Is Lift Available(क्या लिफ्ट है?)<span class="text-danger">*</span> <span className="text-danger">*</span></Form.Label>
                                            <div>
                                            <Form.Check 
                                                type="radio"
                                                label="Service Lift"
                                                name="select_to_lift"    // Updated name attribute
                                                value="To Service Lift"
                                                id="Service Lift"
                                                onChange={handleChange}
                                                checked={formData.select_to_lift === "To Service Lift"}
                                                inline
                                                required
                                            />
                                            <Form.Check 
                                                type="radio"
                                                label="Passenger Lift"
                                                name="select_to_lift"    // Updated name attribute
                                                value="To Passenger Lift"
                                                id="Passenger to Lift"
                                                onChange={handleChange}
                                                checked={formData.select_to_lift === "To Passenger Lift"}
                                                inline
                                            />

                                            <Form.Check 
                                                type="radio"
                                                label="Stairs"
                                                name="select_to_lift"    // Updated name attribute
                                                value="To Stairs"
                                                id="stairs_to"
                                                onChange={handleChange}
                                                checked={formData.select_to_lift === "To Stairs"}
                                                inline
                                            />
                                        </div>
                                        </Form.Group>
                                        
                                        <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" controlId="exampleForm.ControlTextarea1" className='mt-3'>
                                            <Form.Label><b>To</b> Address (पता)</Form.Label>
                                            <Form.Control as="textarea" rows={3} placeholder="Customer Address.." onChange={handleChange} name="to_address" value={formData.to_address}/>
                                        </Form.Group>
                                    
                                        {/* <Form.Group as={Col} xs="12" sm="12" md="2" lg="2" xl="2" xxl="2" controlId="formGridEmail" className='mt-2'>
                                            <Form.Label>From City/Area</Form.Label>
                                            <Form.Control type="text" placeholder="From.." onChange={handleChange} name="from_city" value={formData.from_city} required/>
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" sm="12" md="2" lg="2" xl="2" xxl="2" controlId="formGridEmail" className='mt-2'>
                                            <Form.Label>To City/Area</Form.Label>
                                            <Form.Control type="text" placeholder="To.." onChange={handleChange} name="to_city" value={formData.to_city} required/>
                                        </Form.Group> */}


                                        <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" controlId="exampleForm.ControlTextarea1" className='mt-3'>
                                            <Form.Label>Shifting Items</Form.Label>
                                            <Form.Control as="textarea" rows={3} placeholder="Shifting Items.." onChange={handleChange} name="shift_items" value={formData.shift_items}/>
                                        </Form.Group>

                                        <h6 className='mb-0 mt-3 bg-gray p-2'>Shifting Charges :</h6>
                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                            <hr className='w-10'/>
                                        </Col>
                                        
                                        
                                         <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className='mt-3 bg-gray p-3 pb-4'>
                                            <Form.Label>Freight Charge (पार्टी से तय kul राशि)<span className="text-danger">*</span></Form.Label>
                                            <Form.Control 
                                                type="number" 
                                                min={0} 
                                                placeholder="Total Amount.." 
                                                name="enter_total_amt" 
                                                value={formData.enter_total_amt || ''} // State se value connect karein
                                                onChange={handleChange}               // onChange handler lagayein
                                                required 
                                            />
                                        </Form.Group>
                                        
                                       <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                            <span className="mb-0 mt-3 d-block">
                                               यदि नीचे दिए गए सभी चार्ज कुल राशि में शामिल हैं, तो <strong className="text-primary">Include in Total</strong> पर टिक रहने दें। अन्यथा, उस पर से टिक हटाकर आप चार्ज जोड़ सकते हैं।{' '}
                                                
                                            </span>
                                            <hr className="w-10" />
                                            </Col> 

                                        {chargesConfig.map(({ key, label }) => (
                                            <Form.Group as={Col} xs="12" sm="12" md="3" lg="3" xl="3" xxl="3" className="mt-3" key={key}>
                                                <div className="d-flex justify-content-between">
                                                <Form.Label>{label}</Form.Label>

                                                <Form.Label
                                                    htmlFor={key}
                                                    className="px-1 d-flex align-items-center gap-2 rounded-3"
                                                >
                                                    <strong className="text-primary">Include in Freight</strong>
                                                    <Form.Check
                                                        id={key}
                                                        type="checkbox"
                                                        checked={includeCharge[key]}
                                                        onChange={handleIncludeToggle(key)}
                                                    />
                                                </Form.Label>
                                                </div>

                                                <Form.Control
                                                    type="text"   // 👈 number ki jagah text
                                                    inputMode="numeric"
                                                    pattern="[0-9]*"
                                                    placeholder={`${label}..`}
                                                    name={`${key}_charge`}
                                                    value={formDatainclude[`${key}_charge`] ?? ''}
                                                    onChange={handleChangeCharge}
                                                    readOnly={includeCharge[key]}
                                                    className={includeCharge[key] ? 'readonly-input' : ''}
                                                    required={!includeCharge[key]}/>

                                                </Form.Group>
                                            ))}


                                        <Form.Group as={Col} xs="12" sm="12" md="3" lg="3" xl="3" xxl="3" controlId="formGridPassword" className='mt-3'>
                                            <Form.Label>Sub Total</Form.Label>
                                            <Form.Control type="number" min={0} className='readonly-input' placeholder="Total.." name="total_charge" value={calculateTotal()} readOnly/>
                                        </Form.Group>

                                        <h6 className='mb-0 mt-3'>Tax Charges :</h6>
                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                            <hr className='w-10'/>
                                        </Col>
                                        
                                        <div className='form-group mt-3 col-md-3 col-lg-3  col-sm-12 col-xs-12'>
                                            <Form.Label for="exampleSelect2">GST (Show/Hide GST)</Form.Label>
                                            <select className='form-select' id="exampleSelect2" onChange={handleChange} name="gst_hide_show" value={formData.gst_hide_show}>
                                                <option value="GST Charge Show">GST Charge Show</option>
                                                <option value="Without GST Quotation">Without GST Quotation</option>
                                                <option value="GST Included in Freight Charge" selected>GST Included in Freight Charge</option>
                                            </select>
                                            
                                            {error?.gst_hide_show && (
                                            <span className="alert alert-danger d-block mb-1 mt-1 pt-1 pb-1">
                                                {error.gst_hide_show && error.gst_hide_show}
                                            </span>
                                            )}
                                        </div>

                                        <div className='form-group mt-3 col-md-3 col-lg-3  col-sm-12 col-xs-12'>
                                            <Form.Label for="exampleSelect2">GST Type</Form.Label>
                                            <select 
                                                className='form-select' 
                                                name="gst_type" 
                                                onChange={handleChange} 
                                                value={formData.gst_type}
                                                disabled={!isGstEnabled} // Agar Included ya Show hai toh Enable rahega
                                            >
                                                <option value="CGST/SGST">CGST/SGST</option>
                                                <option value="IGST">IGST</option>
                                            </select>
                                            {error?.gst_type && (
                                            <span className="alert alert-danger d-block mb-1 mt-1 pt-1 pb-1">
                                                {error.gst_type && error.gst_type}
                                            </span>
                                            )}
                                        </div>

                                        <div className='form-group mt-3 col-md-3 col-lg-3  col-sm-12 col-xs-12'>
                                            <Form.Label for="exampleSelect2">GST %</Form.Label>
                                                {/* // GST % Select */}
                                                <select 
                                                    className='form-select' 
                                                    name="gst_per" 
                                                    onChange={handleChange} 
                                                    value={formData.gst_per}
                                                    disabled={!isGstEnabled} // Same condition yahan bhi
                                                >
                                                    <option value="" disabled>Select % </option>
                                                    <option value="0">0%</option>
                                                    <option value="5">5%</option>
                                                    <option value="12">12%</option>
                                                    <option value="18">18%</option>
                                                    <option value="28">28%</option>
                                                </select>
                                            {error?.gst_per && (
                                            <span className="alert alert-danger d-block mb-1 mt-1 pt-1 pb-1">
                                                {error.gst_per && error.gst_per}
                                            </span>
                                            )}
                                        </div>

                                        <Form.Group as={Col} xs="12" sm="12" md="3" lg="3" xl="3" xxl="3" controlId="formGridPassword" className='mt-3'>
                                            <Form.Label>GST Charge</Form.Label>
                                            <Form.Control type="number" min={0} className='readonly-input' placeholder="Total GST Charge.." name="total_gst_charge" value={formData.total_gst_charge} readOnly/>
                                        </Form.Group>

                                        {/* <Form.Group as={Col} xs="12" sm="12" md="3" lg="3" xl="3" xxl="3" controlId="formGridPassword" className='mt-3'>
                                            <Form.Label>Service Charge</Form.Label>
                                            <Form.Control type="number" min={0} placeholder="Service Charge.." onChange={handleChange} name="service_charge" value={formData.service_charge}/>
                                        </Form.Group> */}

                                        <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" controlId="exampleForm.ControlTextarea1" className='mt-3'>
                                            <Form.Label>Notes (पार्टी की कोई अतिरिक्त जानकारी हो तो यहाँ लिखें…)</Form.Label>
                                            <Form.Control as="textarea" rows={3} placeholder="Notes.." name="Notes" value={formData.Notes} onChange={handleChange}/>
                                        </Form.Group>

                                        <div className='d-flex align-items-center submit_btn_sec'>
                                            <Button variant="primary" type="submit" className='d-flex align-items-center justify-content-center'>
                                                <span className='mx-2'>Submit</span>
                                                {loading && <span className='spin-sm'><Loader /></span>}
                                            </Button>
                                            <Button variant="secondary" type="reset" onClick={resetForm} className='mx-2'>
                                                Reset
                                            </Button>
                                        </div>
                                    </Row>

                                    
                                </Form>
                            </Card.Body>
                        </Card>
                </Container>
            </div>
            <MobileNavigation/>
        </div>
    </>
  )
}

export default CretaeQuotation
